import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import FieldToolTip from '@/components/forms/new/FieldToolTip';
import { Field } from 'formik';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import {
    formLabelStyling,
    stackStyling,
} from '@/components/forms/new/formStyles';
import walkthroughIds from '../../walkthroughIds';

const NumbersAddressDropdown = ({
    data,
    accountScope,
    setCurrentNumber,
    errors,
    touched,
    darkMode,
    addresses,
}) => {
    const handleSelectChange = (item) => {
        setCurrentNumber((prev) => ({
            ...prev,
            addressID: item.id,
        }));
    };

    const [isHovered, setIsHovered] = useState(false);
    const fieldName = 'formValues[0].addresses';

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={errors?.addresses && touched?.addresses}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" sx={{ ...stackStyling(), width: '740px' }}>
                <Box width={190}>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Address
                    </FormLabel>
                </Box>
                <Field
                    component={DropDown}
                    id={fieldName}
                    name={fieldName}
                    shownValue="description"
                    currentId={data?.addressID}
                    handleSelectChange={handleSelectChange}
                    accountScope={accountScope}
                    darkMode={darkMode}
                    data={addresses}
                    data-walkthroughid={
                        walkthroughIds.editNumbersGeneral.ufAddress
                    }
                />
                {isHovered && (
                    <FieldToolTip
                        label="Address attached to the Number"
                        ariaLabel="numbers-address-dropdown-tooltip"
                        right="25px"
                        top="23px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default NumbersAddressDropdown;
